export enum ShopId {
  DE = 'DE',
  CH = 'CH',
  PL = 'PL',
  NL = 'NL',
}

export enum Region {
  DE = 'germany',
  CH = 'switzerland',
  NL = 'netherlands',
}

export const REGIONS = Object.values(Region);
